const CREATOR_SIGN_IN_URL =
  process.env.REACT_APP_CREATOR_DASHBOARD_URL ||
  (typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? 'http://localhost:3000/signin'
    : 'https://ugc3-creator-dasboard.web.app/signin');

/** Map Firestore userType to a simple label for messaging */
export function normalizeAccountType(userType) {
  if (!userType) return 'none';
  const t = String(userType).toLowerCase();
  if (t === 'creator') return 'creator';
  if (t === 'brand' || t === 'client') return 'brand';
  if (t === 'admin' || t === 'operator') return 'admin';
  return 'unknown';
}

export function getCreatorDashboardSignInUrl() {
  return CREATOR_SIGN_IN_URL;
}

/**
 * User-facing message when brand dashboard rejects or conflicts with an existing account.
 * @param {string} accountType - creator | brand | admin | unknown | none
 * @param {{ authProviders?: string[], context?: 'onboarding' | 'signin' }} options
 */
export function getAccountTypeMessage(accountType, options = {}) {
  const { authProviders = [], context = 'signin' } = options;
  const usesGoogle = authProviders.some((p) => p === 'google.com');
  const usesPassword = authProviders.some((p) => p === 'password');

  switch (normalizeAccountType(accountType)) {
    case 'creator':
      return `This email is registered as a creator account. Use the creator dashboard to sign in${usesGoogle ? ' (Continue with Google)' : ''}, or use a different email for this brand invite.`;
    case 'brand':
      if (context === 'onboarding') {
        return 'This email is already registered as a brand account. Sign in with Google or your existing password instead of creating a new account.';
      }
      return 'This email is already registered as a brand account. Sign in with your existing password or Continue with Google.';
    case 'admin':
      return 'This email is registered as an admin account. Use a different email for brand sign-up, or contact support.';
    case 'unknown':
      return 'This email is already registered with an account type we cannot use for brand sign-up. Try Continue with Google, sign in with your existing password, or contact support.';
    case 'none':
    default:
      if (usesGoogle && !usesPassword) {
        return 'This email already has a Google sign-in. Use Continue with Google above — do not create a new password here.';
      }
      if (usesPassword && !usesGoogle) {
        return 'This email already has a password sign-in. Sign in with your existing password, or use Continue with Google if you linked Google later.';
      }
      return 'This email already has an account. If you used Google before, use Continue with Google. Otherwise sign in with your existing password.';
  }
}

/** Message after Firebase auth when we have the signed-in user's Firestore profile */
export function getDenialMessageFromUserData(userData) {
  if (!userData) return null;
  return getAccountTypeMessage(userData.userType, { context: 'signin' });
}

export function isBrandDashboardAllowedUserType(userType) {
  if (!userType) return true;
  const t = normalizeAccountType(userType);
  return t === 'brand';
}

export function shouldRedirectToCreatorDashboard(userType) {
  return normalizeAccountType(userType) === 'creator';
}
